import { createSlice } from "@reduxjs/toolkit";
import { FontsResponse } from "../../server/types/index.js";
import { Fonts, FontsByFamily } from "../types/index.js";
import { fetch } from "../utils/utils.js";
import { showAlert } from "./alerts.js";
import { createAppAsyncThunk } from "./utils.js";

const sliceName = "fonts";

const initialState: Fonts = { byFamily: {}, allFamilies: [] };

export const getFonts = createAppAsyncThunk(
  `${sliceName}/getFonts`,
  (_: void, { dispatch }) =>
    fetch({ dispatch, authorize: false })
      .get("fonts")
      .json<FontsResponse>()
      .then((res) => res.fonts)
      .catch((error) => {
        dispatch(showAlert("Die Schriftarten konnten nicht geladen werden!"));
        throw error;
      }),
  {
    condition: (_: void, { getState }) =>
      getState().loadStates.fonts === "unloaded",
  },
);

const slice = createSlice({
  name: sliceName,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getFonts.fulfilled, (state, { payload }) => {
      state.allFamilies = payload.map(({ family: id }) => id);
      state.byFamily = payload.reduce<FontsByFamily>(
        (acc, font) => ({ ...acc, [font.family]: font }),
        {},
      );
    });
  },
});

export default slice.reducer;
